<template>
  <div class="statistics-page">
    <!-- 顶部选择栏 -->
    <div class="header-bar">
      <div class="org-select-card">
        <van-dropdown-menu
          class="custom-dropdown-menu"
          active-color="#3478f6"
        >
          <van-dropdown-item
            v-model="org"
            :options="orgOptions"
            title-class="custom-dropdown-title"
            option-class="custom-dropdown-option"
          />
        </van-dropdown-menu>
      </div>
      <span class="advanced-search" @click="onAdvancedSearch">周课表</span>
    </div>

    <!-- 数据统计卡片 -->
    <div class="stats-cards">
      <div class="card">
        <div class="card-title">记录课时</div>
        <div class="card-value">{{ totalLessons }}</div>
      </div>
      <div class="card">
        <div class="card-title">待上课课时</div>
        <div class="card-value">{{ pendingLessons }}</div>
      </div>
    </div>

    <!-- 分课程类型饼图 -->
    <div class="chart-section">
      <div class="chart-title">分课程类型</div>
      <div ref="pieChart" class="pie-chart"></div>
      <ul class="chart-legend">
        <li v-for="item in courseTypes" :key="item.name">
          <span :style="{ background: item.color }" class="legend-dot"></span>
          {{ item.name }} {{ item.value }}
        </li>
      </ul>
    </div>

    <!-- 分班级课时表格 -->
    <div class="table-section">
      <div class="table-title">分班级</div>
      <div class="custom-table">
        <div class="table-header">
          <span class="th th-class">班级</span>
          <span class="th th-hours">记录课时</span>
        </div>
        <div class="table-row" v-for="row in classRows" :key="row.name">
          <span class="td td-class">{{ row.name }}</span>
          <span class="td td-hours">{{ row.hours }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import * as echarts from 'echarts'

const org = ref('1')
const orgOptions = [
  { text: '铁一旗舰校（高中部）', value: '1' },
  { text: '工大旗舰校2023', value: '2' },
  { text: '成都市青羊分校', value: '3' }
]

const totalLessons = 30
const pendingLessons = 6

const courseTypes = [
  { name: '文科', value: 10, color: '#5470C6' },
  { name: '特训班', value: 20, color: '#91CC75' },
  { name: '理科', value: 20, color: '#FAC858' },
  { name: '其他', value: 20, color: '#EE6666' }
]

const classRows = [
  { name: '特训班', hours: 8 },
  { name: '文科班', hours: 10 }
]

const pieChart = ref(null)

const onAdvancedSearch = () => {
  // 实现高级查询逻辑
  alert('高级查询功能开发中')
}

onMounted(() => {
  const chart = echarts.init(pieChart.value)
  chart.setOption({
    tooltip: { trigger: 'item' },
    series: [
      {
        name: '课程类型',
        type: 'pie',
        radius: ['60%', '80%'],
        avoidLabelOverlap: false,
        label: { show: true, position: 'center', fontSize: 24, formatter: '{c}' },
        emphasis: { label: { show: true, fontSize: 28, fontWeight: 'bold' } },
        labelLine: { show: false },
        data: courseTypes.map(item => ({
          value: item.value,
          name: item.name,
          itemStyle: { color: item.color }
        }))
      }
    ]
  })
})
</script>

<style scoped>
.statistics-page {
  background: #f5f6fa;
  min-height: 100vh;
  padding-bottom: 20px;
}
.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 12px 0 12px;
  background: transparent;
}
.org-select-card {
  display: flex;
  align-items: center;
  /* background: #fff; */
  /* border-radius: 14px; */
  /* box-shadow: 0 2px 12px rgba(52,120,246,0.08); */
  /* padding: 0 18px; */
  /* height: 44px; */
}
.custom-dropdown-menu {
  background: transparent;
  box-shadow: none;
  min-width: 140px;
}
.custom-dropdown-title {
  color: #222;
  font-size: 18px;
  font-weight: 700;
  padding: 0 8px;
}
.advanced-search {
  color: #3478f6;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 10px;
  transition: color 0.2s;
}
.advanced-search:hover {
  color: #174ea6;
}
.stats-cards,
.chart-section,
.table-section {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(52,120,246,0.08);
  margin: 0 12px 18px 12px;
  padding: 16px 0 8px 0;
}
.stats-cards {
  display: flex;
  justify-content: space-around;
  margin-top: 18px;
  margin-bottom: 18px;
  padding: 0;
  box-shadow: none;
  background: transparent;
}
.card {
  background: #fff;
  border-radius: 14px;
  width: 44vw;
  padding: 16px 0;
  text-align: center;
  box-shadow: 0 2px 8px #f0f1f2;
}
.card-title {
  color: #888;
  font-size: 14px;
}
.card-value {
  font-size: 28px;
  color: #222;
  margin-top: 8px;
  font-weight: bold;
}
.chart-title {
  font-size: 16px;
  font-weight: 500;
  margin-left: 16px;
  margin-bottom: 8px;
}
.pie-chart {
  width: 100%;
  height: 180px;
}
.chart-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 8px;
  padding: 0 12px;
  list-style: none;
}
.chart-legend li {
  margin-right: 16px;
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
}
.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
}
.table-title {
  font-size: 16px;
  font-weight: 500;
  margin-left: 16px;
  margin-bottom: 8px;
}
/* 分班级自定义表格美化 */
.custom-table {
  margin: 0 12px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  font-size: 15px;
}
.table-header {
  display: flex;
  background: #f7f8fa;
  font-weight: 700;
  color: #222;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f1f2;
}
.th {
  flex: 1;
}
.th-class {
  text-align: left;
}
.th-hours {
  text-align: right;
}
.table-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f1f2;
  color: #333;
  background: #fff;
  transition: background 0.2s;
}
.table-row:last-child {
  border-bottom: none;
}
.td {
  flex: 1;
}
.td-class {
  text-align: left;
  color: #222;
}
.td-hours {
  text-align: right;
  font-weight: 600;
  color: #3478f6;
}
/* 让机构选择下拉按钮完全透明无背景 */
::v-deep .van-dropdown-menu__bar {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
}
</style> 